import { Grid2 } from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FileTypeEnum } from "../../_common/enum";
import { StandardList } from "../../_components/list/standardList.component";
import { StandardListItem } from "../../_components/list/standardListItem.component";
import { toastr } from "../../_components/toastr/toastr";
import { getDateString } from "../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { fileUploadService } from "../../_services/fileUpload.service";

export const NewsFileList = () => {

    const { newsId } = useParams<{ newsId: string }>();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<any>({ items: [] });

    const hasFiles = data?.items?.length > 0;

    useEffect(() => {
        if (newsId != null) fetchData();
    }, [newsId]);


    function fetchData() {
        if (!newsId) return;
        setIsLoading(true);
        return fileUploadService.getAll(FileTypeEnum.NewsFile, newsId)
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }


    function download(id: string) {
        return fileUploadService.download(id, FileTypeEnum.NewsFile);
    }


    function disable(id: string) {
        if (!id) return;
        setIsLoading(true);

        return fileUploadService
            .disable(id)
            .then(
                () => {
                    toastr.success("File deleted successfully");
                    fetchData();
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    if (!isLoading && !hasFiles)
        return null;

    return (
        <>
            <Grid2 sx={{ mt: 2, width: "100%" }}>Files</Grid2>
            <Grid2 sx={{ width: "100%" }}>
                <StandardList isLoading={isLoading}>
                    {(!isLoading) && data.items.map((item: any, index: number) => (
                        <StandardListItem
                            primary={item.fileName}
                            secondary={getDateString(item.uploadedDate)}
                            buttons={[
                                { icon: "download", onClick: () => download(item.fileUploadId), variant: "primary" },
                                { icon: "delete", onClick: () => disable(item.fileUploadId), variant: "error" },
                            ]}
                            key={item.id}

                        />

                    ))}

                </StandardList>
            </Grid2>
        </>
    );
};

